export default {
  getProjectCalendarData: (state: any) => state.projectCalendarData,
  getTeamCalendarData: (state: any) => state.teamCalendarData,
};
